import React from 'react';

// INTERFACES
import { ICard } from '../../interfaces/Card.interface';

// STYLES
import { 
  CardStyled, 
  CardTitleStyled, 
  CardDescriptionStyled 
} from './styles';

const Card: React.FC<ICard> = ({ 
  children, 
  description, 
  hasMarginRight = false, 
  title 
}) => {
  return (
    <CardStyled hasMarginRight={hasMarginRight}>
      <CardTitleStyled>{title}</CardTitleStyled>
      <CardDescriptionStyled>{description}</CardDescriptionStyled>
      {children}
    </CardStyled>
  );
};

export default Card;
